import React from "react";
import "./label.css";

const Label = () => {
  return (
    <div className="label">
      Please check the travel advisory issued by the concerned state
      government/local authorities before booking, as some places may have
      COVID-19 related travel/lodging restrictions. <br/>
      Note -  ISKCON Puri does not have Hotel Booking. So we arrange accomodation with help of other Hotel Bookings at Puri
    </div>
  );
};

export default Label;
